import React from "react";
import { Modal } from "react-bootstrap";

const SimpleModal = (props) => {
  const { show, handleClose, size } = props;
  return (
    <Modal onClose={handleClose} size={size} show={show} onHide={handleClose}>
      <div className="btn-modal-close" onClick={() => handleClose()}>
        <i className="fa fa-times close-btn"></i>
      </div>
      <Modal.Body>{props.children}</Modal.Body>
    </Modal>
  );
};

export default SimpleModal;
